(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/bigstat.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/bigstat.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const _ReactRedux = ReactRedux,
  Provider = _ReactRedux.Provider;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const Sportinfo = svs.components.sportinfo.sportinfo.Sportinfo;
const EmptyNotice = svs.component.tipsenEmptyNotice.EmptyNotice;
const _RTK = RTK,
  combineReducers = _RTK.combineReducers,
  configureStore = _RTK.configureStore;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux,
  sportEventReducer = _svs$components$sport.sportEventReducer,
  leagueReducer = _svs$components$sport.leagueReducer,
  sportReducer = _svs$components$sport.sportReducer,
  participantReducer = _svs$components$sport.participantReducer,
  countryReducer = _svs$components$sport.countryReducer,
  eventTypeStatisticReducer = _svs$components$sport.eventTypeStatisticReducer,
  generateParticipantsMw = _svs$components$sport.generateParticipantsMw,
  matchInfoActions = _svs$components$sport.actions;
const gameAnalysesReducer = svs.components.sportinfo.gameAnalysesRedux.gameAnalysesReducer;
const newsTTReducer = svs.components.sportinfo.newsTT.newsTTReducer;
const _svs$components$sport2 = svs.components.sportinfo.bigstat,
  BigStatFallback = _svs$components$sport2.BigStatFallback,
  OptionalBrowserRouter = _svs$components$sport2.OptionalBrowserRouter;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const themeClass = svs.components.sportinfo.sportinfo.helpers.themeClass;
const ContentHandler = svs.components.sportInfo.contentHandler.ContentHandler;
const _svs$components$sport3 = svs.components.sportInfo.bigStatBanner,
  BigStatBanner = _svs$components$sport3.BigStatBanner,
  BannerpropsHandler = _svs$components$sport3.BannerpropsHandler,
  BigstatBannerSkeleton = _svs$components$sport3.BigstatBannerSkeleton;
const setupStore = preloadedState => {
  const store = configureStore({
    reducer: combineReducers({
      SportEvents: sportEventReducer,
      Leagues: leagueReducer,
      Sports: sportReducer,
      Participants: participantReducer,
      Countries: countryReducer,
      EventTypeStatistic: eventTypeStatisticReducer,
      gameAnalyses: gameAnalysesReducer,
      newsTT: newsTTReducer
    }),
    middleware: getDefaultMiddleware => [...getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    }), generateParticipantsMw([{
      action: matchInfoActions.updateMatchOdds,
      getMatchIdFn: action => action.payload.matchId
    }, {
      action: matchInfoActions.fetchMatchInfo.fulfilled,
      getMatchIdFn: action => action.meta.arg
    }])],
    preloadedState: _objectSpread({}, preloadedState)
  });
  return store;
};
const setScrollHeight = () => {
  var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4, _document$querySelect5;
  const innerHeight = window.innerHeight || 0;
  const tabContent = document.querySelector('.js-bigstat-tab-content');
  const jsTopContentWrapper = ((_document$querySelect = document.querySelector('.js-top-content-wrapper')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientHeight) || 0;
  const jsProductBaseTabsNav = ((_document$querySelect2 = document.querySelector('.js-product-base-tabs-nav')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.clientHeight) || 0;
  const campaignFlerpContainer = ((_document$querySelect3 = document.querySelector('.campaign-flerp-container')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.clientHeight) || 0;
  const bigStatBanner = ((_document$querySelect4 = document.querySelector('.sportinfo-bigstat-banner')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.clientHeight) || 0;
  const menuWrapper = ((_document$querySelect5 = document.querySelector('.side-nav-statistics-menu')) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.clientHeight) || 0;
  if (tabContent) {
    tabContent.style.height = "".concat(innerHeight - jsTopContentWrapper - jsProductBaseTabsNav - bigStatBanner - campaignFlerpContainer - menuWrapper, "px");
  }
};
const BigStat = _ref => {
  let _ref$activeTabBasePat = _ref.activeTabBasePaths,
    activeTabBasePaths = _ref$activeTabBasePat === void 0 ? [] : _ref$activeTabBasePat,
    appendTabSearchParams = _ref.appendTabSearchParams,
    _ref$basePath = _ref.basePath,
    basePath = _ref$basePath === void 0 ? '/' : _ref$basePath,
    branding = _ref.branding,
    className = _ref.className,
    classNameWrapper = _ref.classNameWrapper,
    drawNumber = _ref.drawNumber,
    eventNumber = _ref.eventNumber,
    _ref$FallbackComp = _ref.FallbackComp,
    FallbackComp = _ref$FallbackComp === void 0 ? EmptyNotice : _ref$FallbackComp,
    forceSportType = _ref.forceSportType,
    _ref$isEnclosedInRout = _ref.isEnclosedInRouter,
    isEnclosedInRouter = _ref$isEnclosedInRout === void 0 ? false : _ref$isEnclosedInRout,
    isWideDevice = _ref.isWideDevice,
    matchId = _ref.matchId,
    _ref$modulePath = _ref.modulePath,
    modulePath = _ref$modulePath === void 0 ? '/' : _ref$modulePath,
    onBannerCloseClick = _ref.onBannerCloseClick,
    productId = _ref.productId,
    setCoupon = _ref.setCoupon,
    sportEventStatus = _ref.sportEventStatus,
    sportType = _ref.sportType,
    _ref$tabAreaClassName = _ref.tabAreaClassName,
    tabAreaClassName = _ref$tabAreaClassName === void 0 ? 'js-bigstat-tab-content bigstat-tab-content' : _ref$tabAreaClassName,
    _ref$tabComponent = _ref.tabComponent,
    tabComponent = _ref$tabComponent === void 0 ? props => React.createElement(Link, _extends({
      replace: true
    }, props)) : _ref$tabComponent,
    theme = _ref.theme;
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const _useState3 = useState(() => setupStore(undefined)),
    _useState4 = _slicedToArray(_useState3, 1),
    store = _useState4[0];
  const defaultErrorFallback = React.createElement(BigStatFallback, {
    branding: branding,
    theme: theme ? themeClass(theme.toLowerCase()) : ''
  }, "Tillf\xE4lligt fel");
  useEffect(() => {
    let timeout;
    const detectWindowResize = () => {
      timeout && window.cancelAnimationFrame(timeout);
      timeout = window.requestAnimationFrame(() => setScrollHeight());
    };
    window.addEventListener('resize', detectWindowResize);
    return () => window.removeEventListener('resize', detectWindowResize);
  }, []);
  useEffect(() => {
    if (isWideDevice || !svs.core.detect.formfactor.mobile()) {
      const bigStatEl = document.querySelector('.js-bigstat-tab-content div');
      let resizeTimer;
      let selectorTimer;
      const runResizeTimer = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          setScrollHeight();
        }, 250);
      };
      const resizeObserver = new ResizeObserver(() => {
        runResizeTimer();
      });
      if (bigStatEl) {
        resizeObserver.observe(bigStatEl);
      } else {
        const runSelectorTimer = () => {
          clearTimeout(selectorTimer);
          selectorTimer = setTimeout(() => {
            const bigStatEl = document.querySelector('.js-bigstat-tab-content div');
            bigStatEl && resizeObserver.observe(bigStatEl);
          }, 250);
        };
        runSelectorTimer();
      }
      return () => {
        if (bigStatEl) {
          resizeObserver.unobserve(bigStatEl);
        }
        clearTimeout(resizeTimer);
        clearTimeout(selectorTimer);
      };
    }
  }, [isWideDevice, matchId, activeTab]);
  if (!productId || !drawNumber || !matchId) {
    return defaultErrorFallback;
  }
  const menuOptions = {
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  };
  const ContentHandlerProps = sportType !== undefined && sportEventStatus !== undefined ? {
    sportType,
    forceSportType,
    sportEventStatus,
    productId,
    matchId
  } : {
    forceSportType,
    matchId,
    productId,
    forceFetchSportEvent: true
  };
  return React.createElement(ErrorBoundary, {
    fallback: () => defaultErrorFallback
  }, React.createElement(Provider, {
    store: store
  }, React.createElement(OptionalBrowserRouter, {
    basename: modulePath,
    isEnclosedInRouter: isEnclosedInRouter
  }, React.createElement("div", {
    className: "".concat(classNameWrapper ? classNameWrapper : '', " ").concat(theme ? themeClass(theme.toLowerCase()) : ''),
    "data-testid": "bigstat"
  }, React.createElement(ContentHandler, ContentHandlerProps, _ref2 => {
    let menuItems = _ref2.menuItems,
      content = _ref2.content,
      matchStateProps = _ref2.matchStateProps,
      lazyComponentsMap = _ref2.lazyComponentsMap;
    return React.createElement(React.Fragment, null, React.createElement(BannerpropsHandler, {
      matchId: matchId,
      productId: productId
    }, (_ref3, isLoading) => {
      let homeTeam = _ref3.homeTeam,
        awayTeam = _ref3.awayTeam,
        leagueName = _ref3.leagueName,
        sportType = _ref3.sportType,
        startTime = _ref3.startTime,
        results = _ref3.results,
        odds = _ref3.odds,
        sportEventStatus = _ref3.sportEventStatus,
        statusTime = _ref3.statusTime;
      if (isLoading || !matchStateProps.matchState) {
        return React.createElement(BigstatBannerSkeleton, null);
      }
      return React.createElement(BigStatBanner, {
        awayTeam: awayTeam,
        homeTeam: homeTeam,
        leagueName: leagueName,
        matchId: matchId,
        matchState: matchStateProps.matchState,
        odds: odds,
        onCloseClick: onBannerCloseClick,
        productId: productId,
        results: results,
        sportEventStatus: sportEventStatus,
        sportType: sportType,
        startTime: startTime,
        statusTime: statusTime
      });
    }), React.createElement(Sportinfo, {
      activeTabBasePaths: activeTabBasePaths,
      appendTabSearchParams: appendTabSearchParams,
      basePath: basePath,
      branding: branding,
      className: "".concat(className ? className : ''),
      content: content,
      drawNumber: drawNumber,
      eventNumber: eventNumber,
      FallbackComp: FallbackComp,
      isWideDevice: isWideDevice,
      lazyComponentsMap: lazyComponentsMap,
      matchId: matchId,
      matchState: matchStateProps.matchState,
      menuItems: menuItems,
      menuOptions: menuOptions,
      productId: productId,
      setActiveTab: setActiveTab,
      setCoupon: setCoupon,
      sportType: matchStateProps.sportType,
      tabAreaClassName: tabAreaClassName,
      tabComponent: tabComponent,
      theme: theme
    }));
  })))));
};
setGlobal('svs.components.sportinfo.bigstat.BigStat', BigStat);

 })(window);